exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Percentage-local__percentage__positive--byswy {\n  color: #06D9B1; }\n\n.Percentage-local__percentage__negative--3rtaK {\n  color: #FB235B; }\n\n.Percentage-local__percentage__warning--30EmU {\n  color: #FFB340; }\n\n.Percentage-local__percentage__great--3lQGX {\n  color: #06D9B1; }\n\n.Percentage-local__percentage__na--2SwZC {\n  color: #6d7f92; }\n", ""]);

// exports
exports.locals = {
	"percentage__positive": "Percentage-local__percentage__positive--byswy",
	"percentage__negative": "Percentage-local__percentage__negative--3rtaK",
	"percentage__warning": "Percentage-local__percentage__warning--30EmU",
	"percentage__great": "Percentage-local__percentage__great--3lQGX",
	"percentage__na": "Percentage-local__percentage__na--2SwZC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/team/team/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/Percentage/Percentage.local.scss
// module id = 1779
// module chunks = 0